import { flattenObj } from "../tag-based-products";

export async function handleBadge(element: HTMLElement) {
  const badgeOptionsStr = element.getAttribute("data-helium-badge-options");
  const badgeConditionStr = element.getAttribute("data-helium-badge-condition");

  if (!badgeOptionsStr) {
    console.warn("No 'data-helium-badge-options' attribute found.");
    return;
  }

  let badgeOptions;
  try {
    badgeOptions = JSON.parse(badgeOptionsStr ?? "{}");
  } catch (e) {
    console.error("Error parsing 'data-helium-badge-options':", e);
    return;
  }

  let badgeCondition;
  try {
    badgeCondition = JSON.parse(badgeConditionStr || "{}");
  } catch (e) {
    console.error("Error parsing 'data-helium-badge-condition':", e);
    return;
  }
  const id =
    element.getAttribute("data-helium-product-handle") ||
    window.location.pathname.split("/").at(-1);
  const [data, tags] = await Promise.all([
    window.helium.datastore.getProduct({ id }),
    window.helium.datastore.getTags({ id }),
  ]);
  const toScanData = flattenObj(
    { ...data.details, ...tags },
    {
      seperator: ".",
    },
  );

  if (!data.details) return;
  const checkCondition = () => {
    if (Object.keys(badgeCondition).length === 0) {
      return true;
    }
    const currentData = toScanData;
    if (!currentData) {
      return false;
    }

    for (const key in badgeCondition) {
      const conditionValue = badgeCondition[key];
      function checkVal(conditionValue: string) {
        const dataValue = currentData[key];
        const isArray = Array.isArray(dataValue);
        if (isArray) {
          if (!dataValue.includes(conditionValue)) {
            return false;
          }
        } else if (dataValue !== conditionValue) {
          return false;
        }
        return true;
      }
      if (Array.isArray(conditionValue)) {
        if (!conditionValue.some(checkVal)) return false;
      } else if (!checkVal(conditionValue)) {
        return false;
      }
    }
    console.log("badgefound");
    return true;
  };

  console.log("badge", toScanData, { checkCondition: checkCondition() });
  if (checkCondition()) {
    const badgeElement = document.createElement("span");
    badgeElement.classList.add(
      ...["blur-scale-in", "hp-flex", "hp-gap-1", "hp-items-center"],
    );
    badgeElement.innerHTML = badgeOptions.text || "Rare Find";
    badgeElement.style.backgroundColor = badgeOptions.color || "grey";
    badgeElement.style.color = badgeOptions["text-color"] || "white";
    badgeElement.style.padding = "0.2rem 0.5rem";
    badgeElement.style.border = "1px solid";
    badgeElement.style.borderRadius = "100rem";
    badgeElement.style.fontSize = "0.8rem";
    badgeElement.style.fontWeight = "700";

    element.innerHTML = ""; // Clear any existing content
    element.appendChild(badgeElement);
    element.style.display = "block"; // Make the container visible
  } else {
    element.style.display = "none"; // Ensure hidden if condition not met
  }
}
